import React from "react"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import { Link } from "gatsby"
import styled from "styled-components/macro"
import Button from "../../Button/Button"
import GalleryIcon from "../../../images/iconmonstr-picture-6.svg"
import NewsIcon from "../../../images/iconmonstr-newspaper-13.svg"
import useGalleryConditional from "../../../hooks/useGalleryConditional.ts"
import useArticleConditional from "../../../hooks/useArticleConditional.ts"

const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  a {
    margin-right: 20px;
  }
`

const HomeIntroLinks = () => {
  if (useGalleryConditional || useArticleConditional) {
    return (
      <ButtonWrapper>
        {useGalleryConditional() && (
          <Button element={Link} icon={<GalleryIcon />} to="/gallery">
            Gallery
          </Button>
        )}
        {useArticleConditional() && (
          <Button element={Link} icon={<NewsIcon />} to="/news">
            News
          </Button>
        )}
      </ButtonWrapper>
    )
  }
  return null
}

export default HomeIntroLinks
